module.exports = __webpack_public_path__ + "img/img-779281.jpg";